import styled, { createGlobalStyle, keyframes } from "styled-components";
import { device } from "common/src/styles/Reset";

export const GlobalStyle = createGlobalStyle`
/*scrollbar handle*/
.thumb.thumbY {
  background: ${(props) => props.theme.themeGlobal.third + " !important"};
  background: ${(props) =>
    (props.scrollBarColor === true ? props.theme.themeGlobal.main : props.theme.themeGlobal.third) + " !important"}
}
`;

export const bounce = keyframes`
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

export const ScrollBarWrapper = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
`;
export const ScrollDown = styled.button`
  display: ${(props) => (props.visible ? "inline-block" : "none")};
  content: " ";
  position: absolute;
  top: 8px;
  right: 0;
  margin: 0 auto;
  background: ${(props) => props.theme.themeGlobal.positive};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${bounce} 2s infinite;
  text-align: center;
  z-index: 150;

  &:after {
    content: " ";
    position: absolute;
    top: 8px;
    left: 10px;
    display: inline-block;
    width: 15px;
    height: 15px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(-45deg);
  }
  @media ${device.landscape} {
    width: 30px;
    height: 30px;
    right: 10px;
    &:after {
      width: 10px;
      height: 10px;
      margin-left: -1px;
    }
  }
  @media ${device.laptop} {
    bottom: 0;
    top: auto;
    cursor: pointer;
  }
`;

export const DbotPanel = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const DbotContainer = styled.div`
  height: 100%;
  overflow: hidden;
`;
